export default __webpack_public_path__ + "retailcab441.png";